import React from 'react'

export default function UpdatePriceModel() {
    return (
        <div>

        </div>
    )
}
